import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const stepperTheme = {
  MuiStepLabel: {
    styleOverrides: {
      root: {
        '&.MuiStep-error .MuiTypography-root': {
          color: tokens.colorAlert
        },
        '&.MuiStep-error .MuiSvgIcon-root': {
          fill: tokens.colorAlert
        }
      }
    }
  },
  MuiStepButton: {
    styleOverrides: {
      root: {
        '&.MuiStep-error .MuiTypography-root': {
          color: tokens.colorAlert
        },
        '&.MuiStep-error .MuiSvgIcon-root': {
          fill: tokens.colorAlert
        }
      }
    }
  }
} satisfies Components;
